import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ApplicationsHeader } from "../../SharedComponents/ApplicationDisplay/ApplicationDisplay";
import { EditableInformation } from "../../SharedComponents/EditableInformation/EditableInformation";
import { NoUserApps } from "../NoUserApps/NoUserApps";
import { UserApplicationDisplayItem } from "../UserApplicationDisplayItem/UserApplicationDisplayItem";
import "./UserProfileApps.css";

export const UserProfileApps = ({ userId }) => {
  const { t } = useTranslation();
  const [workflowApps, setWorkflowApps] = useState([]);
  const [inventoryApps, setInventoryApps] = useState([]);
  const { data, loading } = useQuery(getUserApps, {
    variables: { userId },
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (data && data.apps) {
      setWorkflowApps(data.apps.filter((x) => x.type === "WORKFLOW"));
      setInventoryApps(data.apps.filter((x) => x.type === "INVENTORY"));
    }
  }, [data]);

  return (
    <div className="UserProfileApps">
      <EditableInformation title={t("profile.myApps")}>
        {!loading && workflowApps.length > 0 && (
          <ApplicationsHeader app="WORKFLOW">
            {workflowApps.map((app) => (
              <UserApplicationDisplayItem app={app} key={app.id} />
            ))}
          </ApplicationsHeader>
        )}
        {!loading && inventoryApps.length > 0 && (
          <ApplicationsHeader app="INVENTORY">
            {inventoryApps.map((app) => (
              <UserApplicationDisplayItem app={app} key={app.id} />
            ))}
          </ApplicationsHeader>
        )}
        {inventoryApps.length === 0 && workflowApps.length === 0 && (
          <NoUserApps />
        )}
      </EditableInformation>
    </div>
  );
};

const getUserApps = gql`
  query apps($userId: String) {
    apps(userId: $userId) {
      id
      name
      type
      accountId
    }
  }
`;
